var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tumbler-prop",on:{"click":_vm.toggleActive}},[_c('label',{class:{ 'active': _vm.active },attrs:{"for":_vm.id}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }